import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { PapiDeviation } from '@wix/da-papi-types';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import MoreActionsButton from '@wix/da-shared-react/pkg/Tier/MoreActionsButton';
import { getIsMyTiersPage } from '../../../selectors/studio';

export interface Props {
  className?: string;
  tier: PapiDeviation;
  iconSizeOverride?: ButtonSize;
}

const TierActionsDropdown: FC<Props> = ({
  className,
  tier,
  iconSizeOverride,
}) => {
  const isMyTiersPage = useSelector(getIsMyTiersPage);

  if (!tier) {
    return null;
  }

  return (
    <MoreActionsButton
      deviation={tier}
      className={className}
      studioOrdering
      size={iconSizeOverride || 'small'}
      afterActionUrl={Url.studio({
        published: isMyTiersPage ? 'tiers' : 'galleries',
      })}
    />
  );
};
TierActionsDropdown.displayName = 'TierActionsDropdown';

export default TierActionsDropdown;
